import React, { useState } from "react"
import { useEffect } from "react";
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import Sidebar from './SideBar';
import Axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { validarCampos, validarArchivo, formatRut, cleanRut, formatRutDV, formatRemuneracion, cleanRemuneracion } from './Validations/TrabajadoresValidation';
import config from './Componentes/config';
import useAuthRedirect from "./Componentes/auth";
import { registrarLog } from './Componentes/logService';
import $ from "jquery";
import TrabajadorModal from './Modals/TrabajadorModal';

const cardImages = {
  DAFA: "/img/dafaLogo.png",
  FUGA: "/img/fugarLogo.png",
  INVE: "/img/idafaLogo.png",
  TRAN: "/img/extasisLogo.png",
  NIDI: "/img/nidiamLogo.png"
};

function DestinationPage() {
  useAuthRedirect();
  const [cookies] = useCookies(['selectedCard']);
  const imageUrl = cardImages[cookies.selectedCard]
  const idEmpresa = cookies.idEmpresa;
  const NombreEmpresa = cookies.NombreEmpresa;
  const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
  const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
  const [isInventario, setisIventatioCollapsed] = useState(true);
  const [isPrevencion, setisPrevencionCollapsed] = useState(true);
  const [isLogistica, setisLogisticaCollapsed] = useState(true);
  const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
  const toggleCollapse = (collapseSetter) => {
    collapseSetter(prevState => !prevState);
  };
  const [showModal, setShowModal] = useState(false);
  // Estados para el componente Trabajadores
  const [empresa, setEmpresa] = useState(idEmpresa);
  const [nombres, setNombres] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [estadoCivil, setEstadoCivil] = useState("");
  const [afp, setAfp] = useState("");
  const [rut, setRut] = useState("");
  const [prevision, setPrevision] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [comuna, setComuna] = useState("");
  const [cargo, setCargo] = useState("");
  const [sueldoB, setsueldoB] = useState("");
  const [centrosCostosList, setCentrosCostosList] = useState([]); // Lista de centros de costos
  const [tipoContrato, setTipoContrato] = useState("");
  const [vigenciaDesde, setVigenciaDesde] = useState("");
  const [vigenciaHasta, setVigenciaHasta] = useState("");
  const [centroCosto, setCentroCosto] = useState("");
  const [sueldoBase, setSueldoBase] = useState("");
  const [TrabajadoresList, setTrabajadores] = useState([]);
  const [editar, setEditar] = useState(false);
  const [id, setID] = useState(0);

  // Estados para validación en tiempo real
  const [errors, setErrors] = useState({});

  // Estados para opciones estandarizadas
  const [nacionalidades, setNacionalidades] = useState([
    "Chilena", "Argentina", "Peruana", "Boliviana", "Colombiana", "Ecuatoriana",
    "Venezolana", "Brasileña", "Paraguaya", "Uruguaya", "Haitiana", "Dominicana"
  ]);
  const [comunas, setComunas] = useState([
    "Concepción", "Talcahuano", "Hualpén", "Chiguayante", "San Pedro de la Paz",
    "Penco", "Tomé", "Lota", "Coronel", "Hualqui", "Santa Juana", "Laja",
    "Yumbel", "Cabrero", "Tucapel", "Antuco", "Quilleco", "San Rosendo",
    "Nacimiento", "Negrete", "Mulchén", "Los Ángeles", "Quilaco", "Santa Bárbara",
    "Alto Biobío", "Lebu", "Arauco", "Curanilahue", "Los Álamos", "Cañete",
    "Contulmo", "Tirúa"
  ]);
  const [estadosCiviles] = useState([
    "Soltero(a)", "Casado(a)", "Divorciado(a)", "Viudo(a)", "Separado(a)", "Conviviente"
  ]);

  // Estados para modales de agregar opciones
  const [showModalNacionalidad, setShowModalNacionalidad] = useState(false);
  const [showModalComuna, setShowModalComuna] = useState(false);
  const [nuevaNacionalidad, setNuevaNacionalidad] = useState("");
  const [nuevaComuna, setNuevaComuna] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [TipoArchivo, setTipoArchivo] = useState("");
  const [tipoArchivoSeleccionado, setTipoArchivoSeleccionado] = useState("Todos");
  const [estadoFiltro, setEstadoFiltro] = useState("Vigente");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [trabajadorSeleccionado, setTrabajadorSeleccionado] = useState(null);

  const ConfirmaRegistro = () => {
    // Primero validar todos los campos
    if (!validateAllFields()) {
      return; // No cerrar modal si hay errores
    }

    Swal.fire({
      title: '¿Estás seguro?',
      text: editar ? "¿Deseas actualizar este trabajador?" : "¿Deseas registrar este trabajador?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: editar ? 'Sí, actualizar!' : 'Sí, registrar!',
      cancelButtonText: 'Cancelar',
      didOpen: () => {
        const container = document.querySelector('.swal2-container');
        const popup = document.querySelector('.swal2-popup');
        if (container) container.style.zIndex = '9999';
        if (popup) popup.style.zIndex = '10000';
      }
    }).then((result) => {
      if (result.isConfirmed) {
        if (editar) {
          UpdateTrabajador();
        } else {
          addTrabajador();
        }
        setShowModal(false);
      }
    });
  }

  // Función de validación en tiempo real
  const validateField = (fieldName, value) => {
    const newErrors = { ...errors };

    if (!value || value === "" || value === "none") {
      newErrors[fieldName] = true;
    } else {
      delete newErrors[fieldName];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Función para validar todos los campos sin cerrar modal
  const validateAllFields = () => {
    const newErrors = {};

    if (!empresa) newErrors.empresa = true;
    if (!nombres) newErrors.nombres = true;
    if (!apellidos) newErrors.apellidos = true;
    if (!nacionalidad || nacionalidad === "none") newErrors.nacionalidad = true;
    if (!fechaNacimiento) newErrors.fechaNacimiento = true;
    if (!estadoCivil || estadoCivil === "none") newErrors.estadoCivil = true;
    if (!afp || afp === "none") newErrors.afp = true;
    if (!rut) newErrors.rut = true;
    if (!prevision || prevision === "none") newErrors.prevision = true;
    if (!domicilio) newErrors.domicilio = true;
    if (!comuna || comuna === "none") newErrors.comuna = true;
    if (!cargo) newErrors.cargo = true;
    if (!sueldoB) newErrors.sueldoB = true;
    if (!tipoContrato || tipoContrato === "none") newErrors.tipoContrato = true;
    if (!vigenciaDesde) newErrors.vigenciaDesde = true;
    if (tipoContrato !== "Indefinido" && !vigenciaHasta) newErrors.vigenciaHasta = true;
    if (!centroCosto || centroCosto === "") newErrors.centroCosto = true;

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const missingFields = Object.keys(newErrors).map(field => {
        const fieldNames = {
          empresa: "Empresa",
          nombres: "Nombres",
          apellidos: "Apellidos",
          nacionalidad: "Nacionalidad",
          fechaNacimiento: "Fecha de Nacimiento",
          estadoCivil: "Estado Civil",
          afp: "AFP",
          rut: "RUT",
          prevision: "Previsión",
          domicilio: "Domicilio",
          comuna: "Comuna",
          cargo: "Cargo",
          sueldoB: "Sueldo base",
          tipoContrato: "Tipo de Contrato",
          vigenciaDesde: "Vigencia Desde",
          vigenciaHasta: "Vigencia Hasta",
          centroCosto: "Centro de Costo",
          sueldoBase: "Sueldo Base"
        };
        return fieldNames[field];
      });

      const toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
      toast.fire({
        icon: 'error',
        title: `Por favor completa los campos marcados en rojo: ${missingFields.join(', ')}`
      });
      return false;
    }

    return true;
  };

  // Funciones para agregar nuevas opciones
  const agregarNacionalidad = () => {
    if (nuevaNacionalidad.trim()) {
      setNacionalidades([...nacionalidades, nuevaNacionalidad.trim()]);
      setNacionalidad(nuevaNacionalidad.trim());
      setNuevaNacionalidad("");
      setShowModalNacionalidad(false);
      validateField('nacionalidad', nuevaNacionalidad.trim());
    }
  };

  const agregarComuna = () => {
    if (nuevaComuna.trim()) {
      setComunas([...comunas, nuevaComuna.trim()]);
      setComuna(nuevaComuna.trim());
      setNuevaComuna("");
      setShowModalComuna(false);
      validateField('comuna', nuevaComuna.trim());
    }
  };

  const editarTrabajador = (val) => {
    setEditar(true);
    setNombres(val.Nombres);
    setApellidos(val.Apellidos);
    setNacionalidad(val.Nacionalidad);
    setFechaNacimiento(val.FechaNacimiento);
    setEstadoCivil(val.EstadoCivil);
    setAfp(val.AFP);
    setRut(formatRutDV(val.Rut));
    setPrevision(val.Prevision);
    setDomicilio(val.Domicilio);
    setComuna(val.Comuna);
    setCargo(val.Cargo);
    setsueldoB(formatRemuneracion(val.sueldo_base));
    setTipoContrato(val.TipoContrato);
    setVigenciaDesde(val.VigenciaDesde);
    setVigenciaHasta(val.VigenciaHasta);
    setCentroCosto(val.centro_costo);
    setSueldoBase(val.sueldo_base || "");
    setID(val.ID_Trabajador);
    setShowModal(true);
  }


  const addTrabajador = () => {
    // La validación ya se hace en ConfirmaRegistro
    const rutSinFormato = cleanRut(rut);
    Axios.post(`${config.API_URL}/CreaTrabajador`, {
      empresa,
      nombres,
      apellidos,
      nacionalidad,
      fechaNacimiento,
      estadoCivil,
      afp,
      rut: rutSinFormato,
      prevision,
      domicilio,
      comuna,
      cargo,
      sueldoB: cleanRemuneracion(sueldoB),
      tipoContrato,
      vigenciaDesde,
      vigenciaHasta,
      centroCosto,
      // El input del formulario actualiza "sueldoB"; "sueldoBase" (que es el campo
      // que usa el servidor para la columna sueldo_base) nunca se asignaba en
      // creación manual y llegaba como "", provocando un error 500. Se envía el valor real.
      sueldoBase: cleanRemuneracion(sueldoB)
    }).then(() => {
      console.log(rutSinFormato);
      getTrabajadores();
      limpiarCampos();
      Swal.fire({
        title: '¡Éxito!',
        text: 'El trabajador ha sido registrado exitosamente.',
        icon: 'success',
        didOpen: () => {
          const container = document.querySelector('.swal2-container');
          const popup = document.querySelector('.swal2-popup');
          if (container) container.style.zIndex = '9999';
          if (popup) popup.style.zIndex = '10000';
        }
      });
      registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Registro de trabajador: ${nombres} ${apellidos}`,
        Estado: 'Éxito',
      });

    }).catch((error) => {
      registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Registro de trabajador: ${nombres} ${apellidos}`,
        Estado: 'Fallo',
      });

      Swal.fire({
        title: 'Algo pasó!!',
        text: 'El trabajador no se pudo registrar!.',
        icon: 'error',
        didOpen: () => {
          const container = document.querySelector('.swal2-container');
          const popup = document.querySelector('.swal2-popup');
          if (container) container.style.zIndex = '9999';
          if (popup) popup.style.zIndex = '10000';
        }
      });
    });
  };

  const UpdateTrabajador = async () => {
    try {
      // La validación ya se hace en ConfirmaRegistro
      const rutSinFormato = cleanRut(rut);
      await Axios.put(`${config.API_URL}/ActualizaTrabajador`, {
        id,
        empresa,
        nombres,
        apellidos,
        nacionalidad,
        fechaNacimiento,
        estadoCivil,
        afp,
        prevision,
        domicilio,
        comuna,
        cargo,
        sueldoB: cleanRemuneracion(sueldoB),
        tipoContrato,
        vigenciaDesde,
        vigenciaHasta,
        centroCosto,
      });
      getTrabajadores();
      limpiarCampos();
      Swal.fire(
        '¡Éxito!',
        'El trabajador ha sido actualizado exitosamente.',
        'success'
      );
      console.log('Registrando log...');
      await registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Update de trabajador: ${id}`,
        Estado: 'Éxito',
      });
    } catch (error) {
      await registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Update de trabajador: ${nombres} ${apellidos} - error ${error.message}`,
        Estado: 'Fallo',
      });
      Swal.fire(
        'Error',
        `No se pudo actualizar el trabajador: ${error.message}`,
        'error'
      );
    }
  };


  const DeleteTrabajador = async (id) => {
    try {
      const res = await Swal.fire({
        title: '¡Cuidado!',
        html: '¿Está seguro de eliminar al trabajador?.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!'
      });

      if (res.isConfirmed) {
        await Axios.delete(`${config.API_URL}/EliminaTrabajador/${id}`);
        await registrarLog({
          Usuario: cookies.usuario,
          Modulo: 'Trabajadores',
          Detalle: `Delete de trabajador: ${id}`,
          Estado: 'Éxito',
        });
        getTrabajadores();
        limpiarCampos();

        Swal.fire(
          'Eliminado!',
          'El trabajador ha sido eliminado exitosamente',
          'success'
        );
      }
    } catch (error) {
      console.error('Error al eliminar al trabajador:', error);
      await registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Delete de trabajador: ${id} - error ${error}`,
        Estado: 'Fallo',
      });
      Swal.fire(
        '¡Algo pasó!',
        'Hubo un error al eliminar al trabajador. Intente nuevamente.',
        'error'
      );
    }
  }


  const limpiarCampos = () => {
    setNombres("");
    setApellidos("");
    setNacionalidad("");
    setFechaNacimiento("");
    setEstadoCivil("");
    setAfp("");
    setRut("");
    setPrevision("");
    setDomicilio("");
    setComuna("");
    setCargo("");
    setTipoContrato("");
    setVigenciaDesde("");
    setVigenciaHasta("");
    setCentroCosto("");
    setSueldoBase("");
    setTipoArchivo("");
    setEditar(false);
    setID(0);
    setErrors({}); // Limpiar errores de validación
  }

  const getTrabajadores = () => {
    // Destruir DataTable antes de hacer la petición para evitar conflictos
    try {
      if ($.fn.dataTable.isDataTable('#dataTable')) {
        const table = $('#dataTable').DataTable();
        if (table) {
          table.destroy();
        }
      }
    } catch (error) {
      console.warn('Error al destruir dataTable:', error);
    }

    Axios.get(`${config.API_URL}/getTrabajadores?id=${idEmpresa}&estado=${estadoFiltro}`)
      .then(res => {
        console.log('aqui:' + res.data); // Verifica si los datos son correctos
        if (Array.isArray(res.data)) {
          setTrabajadores(res.data); // Actualiza los trabajadores
          console.log('Datos:');
        } else {
          console.log('No hay Datos:');
          setTrabajadores([]); // Si la respuesta no es un array, inicializa la lista vacía
        }
      })
      .catch(err => {
        console.error("Error al obtener los datos:", err);
        setTrabajadores([]); // En caso de error, limpiar la lista
      });
  };

  const obtenerTrabajador = (id) => {
    Axios.get(`${config.API_URL}/getTrabajadores?idTrabajador=${id}`)
      .then(res => {
        const data = Array.isArray(res.data) ? res.data[0] : res.data;

        if (data) {
          setTrabajadorSeleccionado(data);
          setMostrarModal(true); // Mostrar el modal solo si hay datos
        } else {
          console.warn("No se encontró el trabajador");
        }
      })
      .catch(err => {
        console.error('Error al obtener trabajador:', err);
      });
  };

  // Función para cargar centros de costos desde la base de datos
  const getCentrosCostos = () => {
    Axios.get(`${config.API_URL}/api/centro-costos?idEmpresa=${idEmpresa}`)
      .then(res => {
        console.log('Centros de costos obtenidos:', res.data);
        if (Array.isArray(res.data)) {
          // Filtrar solo los centros activos
          const centrosActivos = res.data.filter(centro => centro.activo === 1 || centro.activo === true);
          setCentrosCostosList(centrosActivos);
        } else {
          console.log('No hay centros de costos disponibles');
          setCentrosCostosList([]);
        }
      })
      .catch(err => {
        console.error("Error al obtener centros de costos:", err);
        setCentrosCostosList([]);
      });
  };


  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onFileUpload = async () => {
    const mensajeError = validarArchivo(selectedFile, TipoArchivo);

    if (mensajeError) {
      Swal.fire('Advertencia', mensajeError, 'warning');
      return; // Detiene la función si falla la validación
    }
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("Rut", cleanRut(rut)); // Suponiendo que 'rut' está disponible en el estado
    formData.append("TipoArchivo", TipoArchivo); // Suponiendo que 'rut' está disponible en el estado
    formData.append("FechaCarga", moment().format('YYYY-MM-DD HH:mm:ss')); // Agrega 'apellidos' si está disponible
    formData.append("UsuarioCarga", cookies.usuario); // Suponiendo que 'mail' contiene la fecha de carga
    try {
      const response = await Axios.post(`${config.API_URL}/SubeArchivo/${cleanRut(rut)}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      Swal.fire(
        '¡Éxito!',
        'El archivo ha sido subido exitosamente.',
        'success'
      );
      fetchFiles();
      await registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Agrega archivo de trabajador: ${id}`,
        Estado: 'Exito',
      });
    } catch (error) {
      await registrarLog({
        Usuario: cookies.usuario,
        Modulo: 'Trabajadores',
        Detalle: `Delete archivo de trabajador: ${id}`,
        Estado: 'Error',
      });
      Swal.fire(
        '¡Algo pasó!',
        'El archivo no ha podido subirse.',
        'error'
      );
    }
  }

  const [files, setFiles] = useState([]);
  const [archivosDB, setArchivosDB] = useState([]);

  const fetchFiles = async () => {
    if (cleanRut(rut)) {
      try {
        const response = await Axios.get(`${config.API_URL}/CargaArchivos`, {
          params: {
            Rut: cleanRut(rut),
            TipoArchivo: tipoArchivoSeleccionado,
          },
        });

        const archivos = Array.isArray(response.data.archivosDB) ? response.data.archivosDB : [];

        // Destruye la tabla antes de actualizar el estado
        try {
          if ($.fn.dataTable.isDataTable("#filesTable")) {
            const table = $('#filesTable').DataTable();
            if (table) {
              table.destroy();
            }
          }
        } catch (error) {
          console.warn('Error al destruir filesTable:', error);
        }

        setArchivosDB(archivos); // Solo actualiza una vez que DataTable esté destruido

      } catch (error) {
        console.error("Error fetching files", error);
        try {
          if ($.fn.dataTable.isDataTable("#filesTable")) {
            const table = $('#filesTable').DataTable();
            if (table) {
              table.destroy();
            }
          }
        } catch (destroyError) {
          console.warn('Error al destruir filesTable en catch:', destroyError);
        }
        setArchivosDB([]);
      }
    }
  };

  const deleteFile = (id) => {
    Swal.fire({
      title: '¡Cuidado!',
      html: '¿Está seguro de eliminar el archivo?.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar!'
    }).then(async (res) => {
      if (res.isConfirmed) {
        try {
          await Axios.delete(`${config.API_URL}/EliminaArchivo/${id}`);
          Swal.fire(
            'Eliminado!',
            'El trabajador ha sido eliminado exitosamente',
            'success'
          );
          fetchFiles();
          await registrarLog({
            Usuario: cookies.usuario,
            Modulo: 'Trabajadores',
            Detalle: `Delete archivo de trabajador: ${id}`,
            Estado: 'Exito',
          });
        } catch (error) {
          await registrarLog({
            Usuario: cookies.usuario,
            Modulo: 'Trabajadores',
            Detalle: `Delete archivo de trabajador: ${id} - error: ${error}`,
            Estado: 'Error',
          });
          Swal.fire(
            'Error!',
            'Hubo un problema al eliminar el archivo. Por favor intente nuevamente.',
            'error'
          );
          console.error('Error al eliminar el archivo:', error);  // Esto es útil para depuración
        }
      }
    });
  };


  const handleRutChange = (event) => {
    const formattedRut = formatRut(event.target.value);
    setRut(formattedRut);
  };

  const handleSueldoBChange = (event) => {
    const formatedSueldoB = formatRemuneracion(event.target.value);
    setsueldoB(formatedSueldoB);
  };

  useEffect(() => {
    fetchFiles();
  }, [rut, tipoArchivoSeleccionado]);


  useEffect(() => {
    if (archivosDB.length > 0) {
      // Asegura que el DOM esté listo antes de aplicar DataTables
      setTimeout(() => {
        const table = document.getElementById('filesTable');
        if (table && !$.fn.dataTable.isDataTable('#filesTable')) {
          $('#filesTable').DataTable({
            responsive: true,
            destroy: true,
            pageLength: 5,
            autoWidth: false,
            language: {
              search: "Buscar:",
              lengthMenu: "Mostrar _MENU_ registros",
              info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
              infoEmpty: "No hay registros disponibles",
              infoFiltered: "(filtrado de _MAX_ registros totales)",
              loadingRecords: "Cargando...",
              zeroRecords: "No se encontraron registros",
              emptyTable: "No hay datos disponibles en la tabla",
              paginate: {
                first: "Primero",
                previous: "Anterior",
                next: "Siguiente",
                last: "Último",
              },
            },
          });
        }
      }, 0); // Espera un ciclo de render
    }
  }, [archivosDB]);


  useEffect(() => {
    // Destruir DataTable existente antes de actualizar los datos
    if ($.fn.dataTable.isDataTable('#dataTable')) {
      $('#dataTable').DataTable().destroy();
    }

    if (TrabajadoresList.length > 0) {
      // Usar setTimeout para asegurar que el DOM se actualice antes de inicializar DataTable
      setTimeout(() => {
        const table = document.getElementById('dataTable');
        if (table && table.querySelector('thead') && !$.fn.dataTable.isDataTable('#dataTable')) {
          $('#dataTable').DataTable({
            responsive: true,
            autoWidth: false,
            pageLength: 10,
            order: [[0, 'desc']],
            language: {
              search: 'Buscar:',
              lengthMenu: 'Mostrar _MENU_ registros',
              info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
              infoEmpty: 'No hay registros disponibles',
              infoFiltered: '(filtrado de _MAX_ registros totales)',
              loadingRecords: 'Cargando...',
              zeroRecords: 'No se encontraron registros',
              emptyTable: 'No hay datos disponibles en la tabla',
              paginate: {
                first: 'Primero',
                previous: 'Anterior',
                next: 'Siguiente',
                last: 'Último',
              },
            },
          });
        }
      }, 0);
    }
  }, [TrabajadoresList]);// Solo se ejecuta cuando TrabajadoresList cambia

  useEffect(() => {
    getTrabajadores();
  }, [estadoFiltro]);

  // Cleanup effect para destruir DataTables cuando el componente se desmonte
  useEffect(() => {
    return () => {
      try {
        if ($.fn.dataTable.isDataTable('#dataTable')) {
          const table = $('#dataTable').DataTable();
          if (table) {
            table.destroy();
          }
        }
        if ($.fn.dataTable.isDataTable('#filesTable')) {
          const table = $('#filesTable').DataTable();
          if (table) {
            table.destroy();
          }
        }
      } catch (error) {
        console.warn('Error al destruir DataTables:', error);
      }
    };
  }, []);

  // useEffect para cargar centros de costos cuando cambie la empresa
  useEffect(() => {
    if (idEmpresa) {
      getCentrosCostos();
    }
  }, [idEmpresa]);

  // Effect para controlar el scroll del body cuando el modal está abierto
  useEffect(() => {
    if (showModal) {
      // Deshabilitar scroll del body cuando el modal está abierto
      document.body.style.overflow = 'hidden';
    } else {
      // Restaurar scroll del body cuando el modal se cierra
      document.body.style.overflow = 'unset';
    }

    // Cleanup: restaurar scroll cuando el componente se desmonte
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  // useEffect para cargar centros de costos cuando cambie la empresa
  useEffect(() => {
    if (idEmpresa) {
      getCentrosCostos();
    }
  }, [idEmpresa]);

  return (
    <body id="page-top">
      <div id="wrapper">
        <Sidebar
          imageUrl={imageUrl}
          cookies={cookies}
          isComponentsCollapsed={isComponentsCollapsed}
          toggleCollapse={toggleCollapse}
          setIsComponentsCollapsed={setIsComponentsCollapsed}
          isUtilitiesCollapsed={isUtilitiesCollapsed}
          setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
          isInventario={isInventario}
          setisIventatioCollapsed={setisIventatioCollapsed}
          isPrevencion={isPrevencion}
          setisPrevencionCollapsed={setisPrevencionCollapsed}
          isLogistica={isLogistica}
          setisLogisticaCollapsed={setisLogisticaCollapsed}
          isContabilidadCollapsed={isContabilidadCollapsed}
          setIsContabilidadCollapsed={setIsContabilidadCollapsed}
        />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content" className="no-extra-padding">
            <div className="container-fluid trabajadores-page">
              <style>{`
                /* ===== Página Trabajadores (estético) ===== */
                .trabajadores-page .tw-toolbar {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 12px;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 1rem;
                }
                .trabajadores-page .tw-filter {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                }
                .trabajadores-page .tw-filter-label {
                  font-weight: 600;
                  color: #5a5c69;
                  white-space: nowrap;
                  margin-bottom: 0;
                }
                .trabajadores-page .tw-filter select { min-width: 180px; }

                /* ===== Tabla ===== */
                .trabajadores-page #dataTable { width: 100% !important; }
                .trabajadores-page #dataTable thead th {
                  background-color: #4e73df;
                  color: #fff;
                  border-color: #4e73df;
                  white-space: nowrap;
                  vertical-align: middle;
                  font-size: .78rem;
                  text-transform: uppercase;
                  letter-spacing: .03em;
                  border-bottom: none;
                }
                .trabajadores-page #dataTable tbody td,
                .trabajadores-page #dataTable tbody th {
                  vertical-align: middle;
                  white-space: nowrap;
                  font-size: .875rem;
                  color: #5a5c69;
                }
                .trabajadores-page #dataTable tbody tr:hover { background-color: #f8f9fc; }

                /* Badges de tipo de contrato */
                .trabajadores-page .tw-badge {
                  display: inline-block;
                  padding: .35em .6em;
                  font-size: .72rem;
                  font-weight: 700;
                  border-radius: 50rem;
                  text-transform: uppercase;
                  letter-spacing: .02em;
                }
                .trabajadores-page .tw-badge-success { background: #e6f4ea; color: #1c7c43; }
                .trabajadores-page .tw-badge-info { background: #e7f1ff; color: #2e59d9; }

                /* Acciones */
                .trabajadores-page .tw-actions { display: flex; gap: 6px; justify-content: center; }

                /* ===== Modales (registro / nacionalidad / comuna) ===== */
                .trabajadores-page .tw-modal { overflow-y: auto; padding: 1.5rem 0; }
                .trabajadores-page .tw-modal .modal-content {
                  border: none;
                  border-radius: .5rem;
                  overflow: hidden;
                  box-shadow: 0 .5rem 1.75rem rgba(34, 34, 34, .35);
                }
                .trabajadores-page .tw-modal .modal-header {
                  background: linear-gradient(135deg, #4e73df 0%, #224abe 100%);
                  color: #fff;
                  border-bottom: none;
                  padding: 1rem 1.25rem;
                }
                .trabajadores-page .tw-modal .modal-header .modal-title { color: #fff; font-weight: 600; background-color: transparent; }
                .trabajadores-page .tw-modal .modal-header .close {
                  color: #fff;
                  opacity: .85;
                  text-shadow: none;
                  font-size: 1.5rem;
                  background-color: transparent;
                  border: none;
                  padding: 0;
                  line-height: 1;
                  cursor: pointer;
                  outline: none;
                  box-shadow: none;
                }
                .trabajadores-page .tw-modal .modal-header .close:hover { opacity: 1; }
                .trabajadores-page .tw-modal .modal-header .close:focus { outline: none; box-shadow: none; }
                .trabajadores-page .tw-modal .modal-body { max-height: 68vh; overflow-y: auto; }
                .trabajadores-page .tw-modal .modal-body h6.text-primary {
                  border-bottom: 1px solid #e3e6f0;
                  padding-bottom: .5rem;
                  margin-bottom: 1rem;
                  font-weight: 700;
                }
                .trabajadores-page .tw-modal .modal-footer { border-top: 1px solid #e3e6f0; }

                /* ===== Responsivo ===== */
                @media (max-width: 576px) {
                  .trabajadores-page .tw-toolbar { flex-direction: column; align-items: stretch; }
                  .trabajadores-page .tw-filter select { min-width: 0; width: 100%; }
                  .trabajadores-page .tw-toolbar .btn-success { width: 100%; }
                }
              `}</style>
              <div className="row">

                <TrabajadorModal
                  isOpen={mostrarModal}
                  trabajador={trabajadorSeleccionado} // Cambio aquí: nombre correcto y claro
                  onClose={() => setMostrarModal(false)}
                />

                <div className="col-lg-12">
                  <br></br>
                  <div className="card shadow mb-4">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Listado de trabajadores de {NombreEmpresa}</h6>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive" style={{ overflowX: 'auto' }}>

                        <div className="tw-toolbar">
                          <div className="tw-filter">
                            <label className="tw-filter-label">Estado:</label>
                            <select
                              className="form-control form-control-sm"
                              value={estadoFiltro}
                              onChange={(e) => setEstadoFiltro(e.target.value)}
                            >
                              <option value="Vigente">Vigente</option>
                              <option value="Deshabilitado">Deshabilitado</option>
                            </select>
                          </div>
                          <>
                            <button
                              className="btn btn-success"
                              onClick={() => {
                                limpiarCampos();
                                setShowModal(true);
                              }}
                            >
                              <i className="fas fa-plus" style={{ marginRight: '5px' }}></i>
                              Registrar trabajador
                            </button>

                            {/* Modal */}
                            {showModal && (
                              <div className="modal fade show tw-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                <div className="modal-dialog modal-lg modal-dialog-centered">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">
                                        <i className="fas fa-user-plus"></i> {editar ? 'Editar Trabajador' : 'Registrar Trabajador'}
                                      </h5>
                                      <button
                                        type="button"
                                        className="close"
                                        onClick={() => {
                                          setShowModal(false);
                                          limpiarCampos();
                                        }}
                                      >
                                        <span>&times;</span>
                                      </button>
                                    </div>
                                    <div className="modal-body">
                                      <div className="row">
                                        {/* Información Personal */}
                                        <div className="col-md-6">
                                          <h6 className="text-primary">Información Personal</h6>

                                          <div className="form-group">
                                            <label>Nombres *</label>
                                            <input
                                              type="text"
                                              className={`form-control ${errors.nombres ? 'is-invalid' : ''}`}
                                              value={nombres}
                                              onChange={(event) => {
                                                setNombres(event.target.value);
                                                validateField('nombres', event.target.value);
                                              }}
                                              placeholder="Ej: Juan Carlos"
                                            />
                                            {errors.nombres && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Apellidos *</label>
                                            <input
                                              type="text"
                                              className={`form-control ${errors.apellidos ? 'is-invalid' : ''}`}
                                              value={apellidos}
                                              onChange={(event) => {
                                                setApellidos(event.target.value);
                                                validateField('apellidos', event.target.value);
                                              }}
                                              placeholder="Ej: González Pérez"
                                            />
                                            {errors.apellidos && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>RUT *</label>
                                            <input
                                              type="text"
                                              className={`form-control ${errors.rut ? 'is-invalid' : ''}`}
                                              value={rut}
                                              onChange={(event) => {
                                                handleRutChange(event);
                                                validateField('rut', event.target.value);
                                              }}
                                              placeholder="Ej: 12.345.678-9"
                                              disabled={editar} // Deshabilitar cuando se está editando
                                              style={editar ? { backgroundColor: '#f8f9fa', color: '#6c757d' } : {}}
                                            />
                                            {errors.rut && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                            {editar && (
                                              <small className="form-text text-muted">
                                                <i className="fas fa-info-circle"></i> El RUT no puede ser modificado en modo edición
                                              </small>
                                            )}
                                          </div>

                                          <div className="form-group">
                                            <label>Nacionalidad *</label>
                                            <div className="input-group">
                                              <select
                                                className={`form-control ${errors.nacionalidad ? 'is-invalid' : ''}`}
                                                value={nacionalidad}
                                                onChange={(event) => {
                                                  setNacionalidad(event.target.value);
                                                  validateField('nacionalidad', event.target.value);
                                                }}
                                              >
                                                <option value="">Seleccione una nacionalidad</option>
                                                {nacionalidades.map((nac, index) => (
                                                  <option key={index} value={nac}>{nac}</option>
                                                ))}
                                              </select>
                                              <div className="input-group-append">
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-primary"
                                                  onClick={() => setShowModalNacionalidad(true)}
                                                  title="Agregar nueva nacionalidad"
                                                >
                                                  <i className="fas fa-plus"></i>
                                                </button>
                                              </div>
                                            </div>
                                            {errors.nacionalidad && <div className="invalid-feedback d-block">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Fecha de Nacimiento *</label>
                                            <input
                                              type="date"
                                              className={`form-control ${errors.fechaNacimiento ? 'is-invalid' : ''}`}
                                              value={fechaNacimiento}
                                              onChange={(event) => {
                                                setFechaNacimiento(event.target.value);
                                                validateField('fechaNacimiento', event.target.value);
                                              }}
                                            />
                                            {errors.fechaNacimiento && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Estado Civil *</label>
                                            <select
                                              className={`form-control ${errors.estadoCivil ? 'is-invalid' : ''}`}
                                              value={estadoCivil}
                                              onChange={(event) => {
                                                setEstadoCivil(event.target.value);
                                                validateField('estadoCivil', event.target.value);
                                              }}
                                            >
                                              <option value="">Seleccione estado civil</option>
                                              {estadosCiviles.map((estado, index) => (
                                                <option key={index} value={estado}>{estado}</option>
                                              ))}
                                            </select>
                                            {errors.estadoCivil && <div className="invalid-feedback d-block">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Sueldo base *</label>
                                            <input
                                              type="text"
                                              className={`form-control ${errors.sueldoB ? 'is-invalid' : ''}`}
                                              value={sueldoB}
                                              onChange={(event) => {
                                                handleSueldoBChange(event);
                                                validateField('sueldoB', event.target.value);
                                              }}
                                              placeholder="Ej: $500.000"
                                            />
                                            {errors.sueldoB && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                          </div>
                                        </div>

                                        {/* Información Laboral y Previsión */}
                                        <div className="col-md-6">
                                          <h6 className="text-primary">Información Laboral y Previsión</h6>

                                          <div className="form-group">
                                            <label>AFP *</label>
                                            <select
                                              className="form-control"
                                              value={afp}
                                              onChange={(event) => setAfp(event.target.value)}
                                            >
                                              <option value="none">Seleccione una AFP</option>
                                              <option value="AFP Capital">AFP Capital</option>
                                              <option value="AFP Cuprum">AFP Cuprum</option>
                                              <option value="AFP Habitat">AFP Habitat</option>
                                              <option value="AFP Modelo">AFP Modelo</option>
                                              <option value="AFP PlanVital">AFP PlanVital</option>
                                              <option value="AFP Provida">AFP Provida</option>
                                              <option value="AFP Uno">AFP Uno</option>
                                            </select>
                                          </div>

                                          <div className="form-group">
                                            <label>Previsión de Salud *</label>
                                            <select
                                              className="form-control"
                                              value={prevision}
                                              onChange={(event) => setPrevision(event.target.value)}
                                            >
                                              <option value="none">Seleccione previsión</option>
                                              <option value="Fonasa">Fonasa</option>
                                              <option value="Isapre Nueva Masvida">Isapre Nueva Masvida</option>
                                              <option value="Isapre Codelco Ltda">Isapre Codelco Ltda</option>
                                              <option value="Isapre Cruz del norte">Isapre Cruz del norte</option>
                                              <option value="Isapre Cruz Blanca S.A.">Isapre Cruz Blanca S.A.</option>
                                              <option value="Isapre Banmedica">Isapre Banmedica</option>
                                              <option value="Isapre VidaTres">Isapre VidaTres</option>
                                              <option value="Isapre Colmena">Isapre Colmena</option>
                                              <option value="Isapre Consalud">Isapre Consalud</option>
                                            </select>
                                          </div>

                                          <div className="form-group">
                                            <label>Domicilio *</label>
                                            <input
                                              type="text"
                                              className={`form-control ${errors.domicilio ? 'is-invalid' : ''}`}
                                              value={domicilio}
                                              onChange={(event) => {
                                                setDomicilio(event.target.value);
                                                validateField('domicilio', event.target.value);
                                              }}
                                              placeholder="Ej: Av. Libertad 123, Las Condes"
                                            />
                                            {errors.domicilio && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Comuna *</label>
                                            <div className="input-group">
                                              <select
                                                className={`form-control ${errors.comuna ? 'is-invalid' : ''}`}
                                                value={comuna}
                                                onChange={(event) => {
                                                  setComuna(event.target.value);
                                                  validateField('comuna', event.target.value);
                                                }}
                                              >
                                                <option value="">Seleccione una comuna</option>
                                                {comunas.map((com, index) => (
                                                  <option key={index} value={com}>{com}</option>
                                                ))}
                                              </select>
                                              <div className="input-group-append">
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-primary"
                                                  onClick={() => setShowModalComuna(true)}
                                                  title="Agregar nueva comuna"
                                                >
                                                  <i className="fas fa-plus"></i>
                                                </button>
                                              </div>
                                            </div>
                                            {errors.comuna && <div className="invalid-feedback d-block">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Cargo *</label>
                                            <input
                                              type="text"
                                              className={`form-control ${errors.cargo ? 'is-invalid' : ''}`}
                                              value={cargo}
                                              onChange={(event) => {
                                                setCargo(event.target.value);
                                                validateField('cargo', event.target.value);
                                              }}
                                              placeholder="Ej: Operario, Supervisor, Administrativo"
                                            />
                                            {errors.cargo && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                          </div>

                                          <div className="form-group">
                                            <label>Tipo de Contrato *</label>
                                            <select
                                              className="form-control"
                                              value={tipoContrato}
                                              onChange={(event) => setTipoContrato(event.target.value)}
                                            >
                                              <option value="none">Seleccione tipo de contrato</option>
                                              <option value="Plazo fijo">Plazo fijo</option>
                                              <option value="Indefinido">Indefinido</option>
                                            </select>
                                          </div>

                                          <div className="form-group">
                                            <label>Centro de Costo *</label>
                                            <select
                                              className="form-control"
                                              value={centroCosto}
                                              onChange={(event) => setCentroCosto(event.target.value)}
                                            >
                                              <option value="">Seleccione centro de costo</option>
                                              {centrosCostosList && centrosCostosList.length > 0
                                                ? centrosCostosList.map((centro) => (
                                                  <option key={centro.id} value={centro.nombre}>
                                                    {centro.nombre}
                                                  </option>
                                                ))
                                                : <option value="" disabled>No hay centros de costo disponibles</option>
                                              }
                                            </select>
                                          </div>
                                        </div>
                                      </div>

                                      {/* Fechas de Vigencia */}
                                      <div className="row mt-3">
                                        <div className="col-md-12">
                                          <h6 className="text-primary">Fechas de Vigencia del Contrato</h6>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label>Vigencia Desde *</label>
                                            <input
                                              type="date"
                                              className="form-control"
                                              value={vigenciaDesde}
                                              onChange={(event) => setVigenciaDesde(event.target.value)}
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="form-group">
                                            <label>Vigencia Hasta *</label>
                                            <input
                                              type="date"
                                              className="form-control"
                                              value={vigenciaHasta}
                                              onChange={(event) => setVigenciaHasta(event.target.value)}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="modal-footer">
                                      <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                          setShowModal(false);
                                          limpiarCampos();
                                        }}
                                      >
                                        <i className="fas fa-times"></i> Cancelar
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={ConfirmaRegistro}
                                      >
                                        <i className="fas fa-save"></i> {editar ? 'Actualizar' : 'Registrar'}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        </div>

                        {/* Modal para agregar nueva nacionalidad */}
                        {showModalNacionalidad && (
                          <div className="modal fade show tw-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    <i className="fas fa-plus"></i> Agregar Nueva Nacionalidad
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                      setShowModalNacionalidad(false);
                                      setNuevaNacionalidad("");
                                    }}
                                  >
                                    <span>&times;</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="form-group">
                                    <label>Nueva Nacionalidad</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={nuevaNacionalidad}
                                      onChange={(e) => setNuevaNacionalidad(e.target.value)}
                                      placeholder="Ej: Española, Francesa, etc."
                                      onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                          agregarNacionalidad();
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setShowModalNacionalidad(false);
                                      setNuevaNacionalidad("");
                                    }}
                                  >
                                    <i className="fas fa-times"></i> Cancelar
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={agregarNacionalidad}
                                    disabled={!nuevaNacionalidad.trim()}
                                  >
                                    <i className="fas fa-plus"></i> Agregar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Modal para agregar nueva comuna */}
                        {showModalComuna && (
                          <div className="modal fade show tw-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    <i className="fas fa-plus"></i> Agregar Nueva Comuna
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                      setShowModalComuna(false);
                                      setNuevaComuna("");
                                    }}
                                  >
                                    <span>&times;</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="form-group">
                                    <label>Nueva Comuna</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={nuevaComuna}
                                      onChange={(e) => setNuevaComuna(e.target.value)}
                                      placeholder="Ej: Quilicura, San Miguel, etc."
                                      onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                          agregarComuna();
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setShowModalComuna(false);
                                      setNuevaComuna("");
                                    }}
                                  >
                                    <i className="fas fa-times"></i> Cancelar
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={agregarComuna}
                                    disabled={!nuevaComuna.trim()}
                                  >
                                    <i className="fas fa-plus"></i> Agregar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <hr></hr>
                        <table className="table table-bordered table-hover" id="dataTable" width="100%" cellspacing="0">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Detalles</th>
                              <th>Nombre completo</th>
                              <th>Rut</th>
                              <th>Cargo</th>
                              <th>Tipo contrato</th>
                              <th>Desde</th>
                              <th>Hasta</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              Array.isArray(TrabajadoresList) && TrabajadoresList.length > 0 ? (
                                TrabajadoresList.map((val, key) => (
                                  <tr key={key}>
                                    <th scope="row">{val.ID_Trabajador}</th>
                                    <td>
                                      <button
                                        onClick={() => obtenerTrabajador(val.ID_Trabajador)}
                                        className="btn btn-info btn-sm"
                                        title="Ver detalles del trabajador"
                                      >
                                        <i className="fas fa-eye"></i> Ver
                                      </button>
                                    </td>
                                    <td data-label="Nombre completo">{val.Nombres + ' ' + val.Apellidos}</td>
                                    <td data-label="Rut">{formatRutDV(val.Rut)}</td>
                                    <td data-label="Cargo">{val.Cargo}</td>
                                    <td data-label="Tipo contrato">
                                      <span className={`tw-badge ${val.TipoContrato === 'Indefinido' ? 'tw-badge-success' : 'tw-badge-info'}`}>
                                        {val.TipoContrato}
                                      </span>
                                    </td>
                                    <td data-label="Desde">{moment(val.VigenciaDesde).format('DD/MM/YYYY')}</td>
                                    <td data-label="Hasta">{val.TipoContrato === 'Indefinido' ? 'Indefinido' : moment(val.VigenciaHasta).format('DD/MM/YYYY')}</td>
                                    <td>
                                      <div className="tw-actions">
                                        <button
                                          type="button"
                                          onClick={() => editarTrabajador(val)}
                                          className="btn btn-warning btn-sm"
                                          title="Editar trabajador"
                                        >
                                          <i className="fas fa-edit"></i>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => { DeleteTrabajador(val.ID_Trabajador); }}
                                          className="btn btn-danger btn-sm"
                                          title="Eliminar trabajador"
                                        >
                                          <i className="fas fa-trash"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr><td colSpan="9">No hay trabajadores disponibles</td></tr>
                              )
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body >
  );
}

export default DestinationPage;
